import apiConfig from '@/services/api.config';
import { SubmitTicketRequest } from 'vopay';
import { useState } from 'react';

const { api } = apiConfig;

export default function useSupportTicket() {
  const [loading, setLoading] = useState(false);

  async function submitTicket(params: SubmitTicketRequest) {
    try {
      setLoading(true);
      const res = await api.submitClientSupportTicket(params);

      return res;
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    submitTicket,
  };
}
